import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';

const ErrorMessages = ({ errors }) => {
  const { t } = useTranslation();

  if (errors.length === 0) return null;

  return (
    <div className="error-message-container-comp">
      <Alert
        type="error"
        showIcon
        title={t('Importovaný súbor obsahuje jednu alebo viacero chýb:')}
        description={
          <ul style={{ paddingLeft: 20, margin: 0 }}>
            {errors.map((message, idx) => (
              <li key={`err-${idx}`}>{message}</li>
            ))}
          </ul>
        }
      />
    </div>
  );
};

ErrorMessages.propTypes = {
  errors: PropTypes.any,
};

export default ErrorMessages;
